const chart = {
  chartInfo: {
    name: "Name",
    gender: "Gender",
    birthDate: "Birth Date",
    solarDate: "Solar Date",
    shengXiao: "Chinese Zodiac",
    fiveElement: "Five Element",
    lunarDate: "Lunar Date",
  },
  
  myChart: {
    title: "My Zi Wei Dou Shu Chart",
    subtitle: "View your personal Zi Wei Dou Shu chart and analysis",
    profileDetails: "Profile Details",
    keySummary: "Key Summary",
    detailedAnalysis: "Detailed Analysis",
    createProfile: "Create Your Profile",
    createProfileDesc: "To generate your personal Zi Wei Dou Shu chart, please provide your birth information.",
    editProfile: "Edit Profile",
    career: "Career & Wealth",
    health: "Health & Wellness",
    relationships: "Relationships & Family",
    lifePurpose: "Life Purpose & Spirituality",
    chartVisualization: "Chart Visualization",
    createOtherProfile: "Create Profile for Someone Else",
    fields: {
      name: "Name",
      type: "Type",
      birthDate: "Birth Date",
      birthTime: "Birth Time",
      gender: "Gender",
      male: "Male",
      female: "Female",
      self: "Self",
      other: "Other"
    }
  },
  
  result: {
    loading: "Loading Chart...",
    chart: "Chart",
    subtitle: "Zi Wei Dou Shu chart analysis",
    profileDetails: "Profile Details",
    chartVisualization: "Chart Visualization",
    chartVisualizationPlaceholder: "This is a placeholder visualization. In the full implementation, this would show an interactive Zi Wei Dou Shu chart.",
    shareChart: "Share",
    print: "Print",
    exportTitle: "Zi Wei Dou Shu Chart Analysis",
    generatedOn: "Generated on",
    confidential: "Confidential Report - For Personal Use Only",
    refreshChart: "Refresh Chart",
    detailedAnalysis: "Detailed Analysis",
    keyInsights: "Key Insights",
    house: "House",
    scrollToView: "Scroll to view entire chart",  
    pinchToZoom: "Pinch to zoom",
    viewportInstructions: "Use zoom controls and scroll to view all parts of the chart",
    fields: {
      relationship: "Relationship",
      birthPlace: "Birth Place",
      generated: "Generated"
    },
    exportPdf: "Export PDF",
    hourAdjustment: {
      title: "Adjust Birth Hour",
      description: "Cycle through the 12 time branches (地支) to explore chart variations",
      original: "Original",
      reset: "Reset to Original",
      previous: "Prev",
      next: "Next"
    },
   
    
  },
  
  pdfExport: {
    title: "Zi Wei Dou Shu Chart Analysis",
    subtitle: "Professional Astrological Report",
    profileTitle: "Profile Information",
    reportGenerated: "Report Generated",
    confidential: "This report is confidential and intended for personal use only.",
    chartDescription: "Chart Description",
    chartInfo: "This Zi Wei Dou Shu chart represents the cosmic influences at the time of birth. Each palace contains specific stars that influence different aspects of life. The arrangement of these stars provides insights into personality, destiny, and life patterns.",
    reportFooter: "End of Report",
    disclaimer: "This report is generated based on traditional Chinese astrology principles. Results should be considered as guidance and not absolute predictions.",
    pageNumber: "Page",
    exporting: "Getting your report ready...",
    success: "Export Complete",
    failed: "Export Failed",
    errorMessage: "We could not finish your download. Please try again.",
    successMessage: "Your chart is ready!",
    downloadStarted: "Your download should begin automatically.",
    processingChart: "Hang tight. We are putting your report together...",
    progress: "Progress",
    chartName: "Chart",
    step1: "Gathering your chart details...",
    step2: "Designing your cover page...",
    step3: "Arranging your chart visuals...",
    step4: "Formatting pages for easy reading...",
    step5: "Wrapping up your download...",
    starting: "Getting your report ready...",
    serverRendering: "Sorting your chart into neat pages you can save or print...",
    serverPhase2:
      "Still working. Full reports like yours can take a little longer...",
    serverPhase3:
      "Still working. If several people export at once, yours waits its turn.",
    noSession: "Please sign in first so we can prepare your chart.",
    noData: "No chart data available for export",
    notSupported: "PDF export is not supported in this browser",
  },
};

export default chart; 